<template lang="pug">
.modal-backdrop(v-if="visible")
  .modal-container
    .info-title 恭喜您成为
    .info-word 哈啰超级会员 专属权益为您开启
    .business-list
      .business-list-item(v-for="(item,index) in commonBonus")
        .business-img
          img.business-top-img(:src="item.bonusEntity.icon")
        .business-title {{item.bonusEntity.mainTitle}}
        .business-word {{item.bonusEntity.subTitle}}
    .footer
      .footer-btn(@click="confirm") 立即去使用
  .modal-close(@click='close')
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getSource } from '../../../../utils';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '去使用',
    },
    amount: {
      type: [String, Number],
      default: null,
    },
    commonBonus: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      param: {}, // close时发送
      businessList: [{
        img: 'https://m.hellobike.com/resource/helloyun/08345/4aNOPSTa6g.png?x-oss-process=image/quality,q_80',
        title: '出行优惠',
        info: '出行28元券',
      }, {
        img: 'https://m.hellobike.com/resource/helloyun/08345/4aNOPSTa6g.png?x-oss-process=image/quality,q_80',
        title: '出行优惠',
        info: '出行28元券',
      }, {
        img: 'https://m.hellobike.com/resource/helloyun/08345/4aNOPSTa6g.png?x-oss-process=image/quality,q_80',
        title: '出行优惠',
        info: '出行28元券',
      }, {
        img: 'https://m.hellobike.com/resource/helloyun/08345/4aNOPSTa6g.png?x-oss-process=image/quality,q_80',
        title: '出行优惠',
        info: '出行28元券',
      }, {
        img: 'https://m.hellobike.com/resource/helloyun/08345/4aNOPSTa6g.png?x-oss-process=image/quality,q_80',
        title: '出行优惠',
        info: '出行28元券',
      }, {
        img: 'https://m.hellobike.com/resource/helloyun/08345/4aNOPSTa6g.png?x-oss-process=image/quality,q_80',
        title: '出行优惠',
        info: '出行28元券',
      }],
    };
  },
  created() {
    UBT.moduleExpose({
      pageId: 'platform_openedcard_page',
      categoryId: 'platform',
      moduleId: 'platform_openedcard_popup',
      contentId: 'platform_openedcard_popup',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
    UBT.moduleExpose({
      pageId: 'platform_openedcard_page',
      categoryId: 'platform',
      moduleId: 'platform_openedcard_use_button',
      contentId: 'platform_openedcard_use_button',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
  },
  methods: {
    open(options, param = {}) {
      this.visible = true;
      this.param = param;
    },
    cancel() {
      this.visible = false;
      this.$emit('cancel', this.param);
    },
    close() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_openedcard_popup',
        categoryId: 'platform',
        businessInfo: {
          adsource: getSource(),
        },
      });
      this.visible = false;
      this.$emit('close', this.param);
    },
    confirm() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_openedcard_popup',
        categoryId: 'platform',
        businessInfo: {
          adsource: getSource(),
        },
      });
      this.$emit('confirm', this.param);
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.modal-backdrop {
  position: fixed;
  z-index: 900;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.modal-container {
  margin: 2.15rem auto;
  width: 3.2rem;
  height: 3.2rem;
  background: url(https://m.hellobike.com/resource/gallery/63/qPxzsdQw_bg-2.png);
  background-size: 100% 100%;
  border-radius: 0.12rem;
  position: relative;
  padding-bottom: 0.2rem;

  .info-first {
    font-size: 0.12rem;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi, sans-serif;
    font-weight: 400;
    color: rgba(68, 29, 6, 0.8);
    padding-top: 0.36rem;
    padding-left: 0.37rem;
  }

  .info-title {
    font-size: 0.18rem;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    line-height: 0.25rem;
    color: #441d06;
    text-align: center;
    padding-top: 0.86rem;
  }

  .info-word {
    font-size: 0.14rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #441d06;
    margin: 0.05rem auto;
    text-align: center;
  }

  .business-list {
    margin-top: 0.21rem;
    padding-left: 0.24rem;
    height: 0.77rem;
    display: flex;
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      color: transparent;
    }

    .business-list-item {
      width: 0.68rem;
      flex: 1;

      .business-img {
        display: flex;
        width: 0.68rem;
        margin: 0 auto;

        img.business-top-img {
          margin: 0 auto;
          width: 0.46rem;
          height: 0.46rem;
        }
      }

      .business-title {
        text-align: center;
        margin-top: -0.02rem;
        font-size: 0.12rem;
        font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
        font-weight: 600;
        color: #6f2500;
        opacity: 0.8;
      }

      .business-word {
        text-align: center;
        transform: scale(0.833);
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: rgba(165, 71, 0, 0.65);
        margin-top: -0.01rem;
      }
    }
  }

  .footer {
    margin-top: 0.2rem;
    padding: 0 0.24rem 0.2rem 0.24rem;
    display: flex;

    .footer-btn {
      height: 0.4rem;
      background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
      border-radius: 0.12rem;
      text-align: center;
      width: 100%;
      font-size: 0.14rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #fffaf8;
      line-height: 0.4rem;
    }
  }
}

.modal-close {
  margin: -1.8rem auto;
  background: url(https://m.hellobike.com/resource/helloyun/08345/3fkTG3TrVs.png?x-oss-process=image/quality,q_80) no-repeat;
  background-size: 100%;
  width: 0.32rem;
  height: 0.32rem;
}
</style>
